import React, { useState, useContext, useEffect } from 'react';
import Popup from 'components/common/popup/popup';
import ViewsContext from 'contexts/viewsContext';
import AppContext from 'contexts/appContext';
import { useTranslation } from 'react-i18next';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';

export default function CategorySalesTableViewGlance(props) {
  function showChart() {
    props.changeViewStateFn();
  }

  const { t } = useTranslation();
  const { viewsState, setCategorySalesTableViewConfig } = useContext(ViewsContext);
  const { appState } = useContext(AppContext);
  const [configureChartsPopupVisible, setConfigureChartsPopupVisible] = useState(false);

  const SortableItem = SortableElement(({ item }) => {
    return (
      <li className='list-group-item formmenu-child' style={{ opacity: '1 !important', visibility: 'visible !important', zIndex: '10000' }}>
        <div className='row'>
          <div className='col-1'>
            <div className='subtle draggable-handle ui-sortable-handle'><i className='icons8-braille' /></div>
          </div>
          <div className='col-9'>{t(item.title)}&nbsp;{item.title !== 'Hour' ? (item.sign) : ''}</div>
          <div className='col-2 text-right'>
            {(() => {
              switch (item.title) {
                case 'Category': return <i className='icons8-lock' style={{ fontSize: '20px', paddingRight: '25px' }} />
                default: return (
                  <div className='custom-control custom-switch' onClick={(value) => {
                    item.isVisible = !item.isVisible;
                    setCategorySalesTableViewConfig(viewsState.chartsAndTableViewsConfigs.categorySalesTableView);
                  }}>
                    <input type='checkbox' className='custom-control-input' checked={item.isVisible} />
                    <label className='custom-control-label'></label>
                  </div>
                );
              }
            })()}
          </div>
        </div>
      </li>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div className='table-view-config'>
        <p>Edit table columns:</p>
        {items.map((value, index) => (
          <SortableItem key={`item-${value.showVar}`} index={index} item={value} />
        ))}
      </div>
    );
  });

  function onSortEnd({ oldIndex, newIndex }) {
    setCategorySalesTableViewConfig(arrayMove(viewsState.chartsAndTableViewsConfigs.categorySalesTableView, oldIndex, newIndex));
  };

  return (
    <>
      <Popup title={t('ConfigureTable')} theme={appState.theme} show={configureChartsPopupVisible} onClose={() => setConfigureChartsPopupVisible(false)}>
        <div>
          <SortableList items={viewsState.chartsAndTableViewsConfigs.categorySalesTableView} onSortEnd={onSortEnd} distance={2} />
        </div>
      </Popup>

      <div className={'panel panel-default glance glance-2x2 togglable togglable-table csales-table-view-body ' + props.viewState} >
        <div className='panel-heading csales-table-view-heading' >
          <div className='edge edge-left'>
            <i className='icons8-pie-chart' aria-hidden='true' />
          </div>
          <div style={{ width: '80%' }}>
            <h3 className='panel-title'>{t('CategorySales')}</h3>
          </div>
          <div className='edge edge-right'>
            <button type='button' className='btn btn-simple btn-left csales-table-view-btn' onClick={() => setConfigureChartsPopupVisible(true)}>
              <i className='icons8-settings' aria-hidden='true' />
            </button>
          </div>
        </div>
        <div className='panel-body table-holder'>
          <HSTable data={props.data} />

        </div>
        <div className='panel-footer '>
          <button className='btn btn-simple btn-default btn-block btn-large csales-table-view-btn' onClick={showChart}>
            <i className='icons8-bar-chart-filled' style={{ borderLeft: '1px solid black', borderBottom: '1px solid black' }} />{t('ShowChart')}
          </button>
        </div>
      </div>
    </>
  );
}

export function HSTable(props) {
  const { t } = useTranslation();
  const { viewsState, setCategorySalesTableViewConfig } = useContext(ViewsContext);
  const [currentSort, setCurrentSort] = useState('default');
  const [currentSortVar, setCurrentSortVar] = useState(null);

  useEffect(() => {
    viewsState.chartsAndTableViewsConfigs.categorySalesTableView.forEach((element) => {
      element.sortDirection = 'default';
    });
    setCategorySalesTableViewConfig(viewsState.chartsAndTableViewsConfigs.categorySalesTableView);
  }, []);

  const Sort = (sortVar) => {
    viewsState.chartsAndTableViewsConfigs.categorySalesTableView.forEach((element) => {
      if (element.sortVar !== sortVar) {
        element.sortDirection = 'default';
      }
      else {
        if (element.sortDirection === 'down') element.sortDirection = 'default';
        else if (element.sortDirection === 'up') element.sortDirection = 'down';
        else if (element.sortDirection === 'default') element.sortDirection = 'up';
        setCurrentSort(element.sortDirection);
        setCurrentSortVar(element.sortVar);
      }
    });
  };

  return (
    props.data.length > 0 && (
      <table className='table table-hover glance-table editable sorted'>
        <thead>
          <tr>
            {
              (typeof viewsState.chartsAndTableViewsConfigs.categorySalesTableView != 'undefined') ?
                viewsState.chartsAndTableViewsConfigs.categorySalesTableView.map((element, i) => {
                  if (element.isVisible === true) {
                    if (element.title === 'Category') {
                      return (<th key={i} className=' text-nowrap' onClick={() => Sort(element.sortVar)}>{t('CategorySales')}
                        <i className={`icons8-${sortTypes[element.sortDirection].class}`} />
                      </th>)
                    }
                    else {
                      return (<th key={i} className='text-right text-nowrap' onClick={() => Sort(element.sortVar)} >{t(element.title)}&nbsp;({element.sign})
                        <i className={`icons8-${sortTypes[element.sortDirection].class}`} />
                      </th>)
                    }
                  }
                  else {
                    return null;
                  }
                }) : <div></div>
            }
          </tr>
        </thead>
        <tbody>
          {(() => {
            return [...props.data].sort(sortTypes[currentSort].fn(currentSortVar)).map((p, index) => (
              <tr key={index}>
                {
                  (typeof viewsState.chartsAndTableViewsConfigs.categorySalesTableView != 'undefined') ?
                    viewsState.chartsAndTableViewsConfigs.categorySalesTableView.map((element, i) => {
                      if (element.isVisible === true) {
                        return (<td key={i} className={element.title !== 'Category' ? 'text-right text-nowrap' : 'text-nowrap'}>
                          {element.sign === '$' ? '$' : ''}{p[element.showVar]}{element.sign === '%' ? '%' : ''}
                        </td>);
                      }
                      else {
                        return null;
                      }
                    }) : <div></div>
                }
              </tr>
            ));
          })()}
        </tbody>
        <tfoot>
          <tr className='total'>
            {
              (typeof viewsState.chartsAndTableViewsConfigs.categorySalesTableView != 'undefined') ?
                viewsState.chartsAndTableViewsConfigs.categorySalesTableView.map((element, i) => {
                  if (element.isVisible === true) {
                    if (element.title === 'Category') {
                      return (<td key={i} className=' '>{t('Total')}</td>)
                    }
                    else {
                      return (<td key={i} className='text-right'>
                        {element.sign === '$' ? '$' : ''}
                        {(props.data.map((item) => item[element.showVar]).reduce((prev, next) => prev + next)).toFixed(2)}
                        {element.sign === '%' ? '%' : ''}
                      </td>)
                    }
                  }
                  else {
                    return null;
                  }
                }) : <div></div>
            }
          </tr>
        </tfoot>
      </table>
    )
  );
}

const sortTypes = {
  up: {
    class: 'sort-up',
    fn: (c) => (a, b) => {
      if (a[c] < b[c]) {
        return -1;
      }
      if (b[c] < a[c]) {
        return 1;
      }
      return 0;
    }
  },
  down: {
    class: 'sort-down',
    fn: (c) => (a, b) => {
      if (a[c] > b[c]) {
        return -1;
      }
      if (b[c] > a[c]) {
        return 1;
      }
      return 0;
    }
  },
  default: {
    class: 'nosort',
    fn: (c) => (a, b) => a[c]
  }
};